export const EMAIL_TEMPLATE_PLACEHOLDERS = {
  employeeInfoLastName: 'employee_info_last_name',
  employeeInfoFirstName: 'employee_info_first_name',
  companyName:'company_name',
  jobName: 'job_name',
  companyPhoneNumber: 'company_phone_number',
  companyEmailAddress: 'company_email_address',
  companyLocationName: 'company_location_name',
  companyDepartment: 'company_department',
  applicantLink: 'applicant_link'
};
